<script setup lang="ts">
import type {Testimonial} from '~/types/legacy'
import type {Populated} from '~/types/populated'
import Star from '~/assets/icons/star.svg?component'
import Quote from '~/assets/icons/quote.svg?component'

const props = defineProps<{
  review: Populated<Testimonial>
}>()
</script>

<template>
  <div class="mx-auto flex flex-col items-center justify-center">
    <Quote width="32" class="mb-2 text-[#D4D4D4]" />

    <Paragraph size="medium" weight="normal" align="center" class="mb-4 mt-2">{{ `${review.message}` }}</Paragraph>
    <Paragraph size="normal" weight="normal" align="center" class="!font-light !text-gray-500">
      {{ `${review.role || ''}${review.role && review.partner?.name ? ',' : ''} ${review.partner?.name || ''}` }}
    </Paragraph>

    <div class="mt-4 flex items-center justify-center gap-2">
      <Star v-for="i of 5" :key="i" class="text-main-500" width="18" />
    </div>
  </div>
</template>
